var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4BA2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55188 4.62891C5.67338 4.64973 5.37075 5.45579 5.5395 6.3766C5.68575 7.16579 7.51219 10.2219 7.43682 11.2704C7.37832 11.9285 5.87869 13.4725 5.72063 13.3696C5.54794 13.3218 6.17625 12.2727 5.94338 11.3986C5.67225 10.3794 4.06463 7.7446 4.06632 6.58135C4.06632 5.73029 5.44388 4.57379 5.55188 4.62891ZM8.98819 3.42516C9.14232 3.4516 8.75757 4.48042 8.97244 5.6521C9.15807 6.6601 11.4885 10.5571 11.3918 11.893C11.3164 12.7334 9.405 14.7005 9.2025 14.5705C8.98313 14.5104 9.78413 13.1722 9.48713 12.0573C9.14232 10.759 7.092 7.39866 7.09369 5.91535C7.09369 4.82916 8.84982 3.35541 8.98819 3.42516ZM12.5348 4.62891C12.6563 4.64973 12.3542 5.45579 12.5224 6.3766C12.6686 7.16579 14.4951 10.2219 14.4203 11.2704C14.3623 11.9285 12.8621 13.4725 12.7035 13.3696C12.5314 13.3218 13.1591 12.2727 12.9263 11.3986C12.6557 10.3794 11.0475 7.7446 11.0492 6.58135C11.0492 5.73029 12.4273 4.57379 12.5348 4.62891Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbd);
export default __webpack_public_path__ + "static/media/sbd.6cfc9edc2208d2085f2e2e33fac4aa3c.svg";
export { ForwardRef as ReactComponent };